import { useNavigate } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Panel } from "@/components/admin/ui";
import { DAY_KEYS, DAY_LABELS } from "@/lib/businessHours";

const fmtTime = (t) => {
  if (!t) return "";
  const [h, m] = t.split(":").map(Number);
  const period = h >= 12 ? "PM" : "AM";
  const hh = h % 12 === 0 ? 12 : h % 12;
  return `${hh}:${String(m).padStart(2, "0")} ${period}`;
};

export const BusinessHoursSummary = ({ hours }) => {
  const navigate = useNavigate();
  return (
    <Panel
      title="Business Hours"
      subtitle="Read-only here — Office is the authoritative place to manage hours for scheduling across Office, People and Sales."
      action={
        <button
          type="button"
          onClick={() => navigate("/dashboard/solutions/office")}
          data-testid="org-settings-manage-hours-in-office-btn"
          className="inline-flex items-center gap-1.5 rounded-xl border border-transparent bg-[#0052FF] px-3.5 py-2 text-xs font-bold text-white transition-colors duration-150 hover:bg-[#0040CC]"
        >
          Manage in Office <ArrowUpRight size={14} />
        </button>
      }
      testId="org-settings-business-hours-summary"
    >
      <div className="space-y-1.5">
        {DAY_KEYS.map((day) => {
          const info = hours?.[day] || {};
          return (
            <div key={day} className="flex items-center justify-between rounded-xl border border-slate-200 px-3 py-2 dark:border-white/10" data-testid={`org-settings-hours-summary-row-${day}`}>
              <span className="text-sm font-semibold text-slate-700 dark:text-slate-200">{DAY_LABELS[day]}</span>
              <span className="text-sm text-slate-500 dark:text-slate-400">{info.closed ? "Closed" : `${fmtTime(info.open)} – ${fmtTime(info.close)}`}</span>
            </div>
          );
        })}
      </div>
    </Panel>
  );
};
